import React from 'react'
import moment from 'moment'
import EventListJob from './EventListJob'
import { formatDayHeading } from './dateUtils'
import { getDefaultExpandedJobId } from './expansionUtils'
import type { PainterScheduleEvent, TabValue } from './types'
import type { usePainterAdditionalWorkStyles } from './usePainterAdditionalWorkStyles'
import type { usePainterJobCardStyles } from './usePainterJobCardStyles'
import type { usePainterWorkOrderStyles } from './usePainterWorkOrderStyles'
import PainterScheduleShim from './PainterScheduleShim'

export interface EventListProps {
  events: PainterScheduleEvent[]
  loading?: boolean
  selectedDay: moment.Moment
  expandedJobId: string | null | false
  activeTabs: Record<string, TabValue>
  expandedCrewNotes: Set<string>
  expandedProducts: Set<string>
  showContactInfo: boolean
  showHours: boolean
  showPrices: boolean
  showPayments: boolean
  showTasksNotesFiles: boolean
  canAddAdditionalWork: boolean
  onSetExpandedJobId: (jobId: string | null | false) => void
  onSetTab: (jobId: string, tab: TabValue) => void
  onToggleCrewNote: (jobId: string) => void
  onToggleProducts: (jobId: string) => void
  callbacks: any
  classes: ReturnType<typeof usePainterJobCardStyles>
  workClasses: ReturnType<typeof usePainterWorkOrderStyles>
  additionalWorkClasses: ReturnType<typeof usePainterAdditionalWorkStyles>
}

export default function EventList(props: EventListProps) {
  const { events, loading, selectedDay, classes } = props
  const eventsForDay = events.filter((event) => {
    const start = moment(event.startDate).startOf('day')
    const end = moment(event.endDate).startOf('day')
    return selectedDay.isBetween(start, end, 'day', '[]')
  })
  const expandedJobId = getDefaultExpandedJobId(eventsForDay, props.expandedJobId)
  return (
    <div className={classes.eventListSection}>
      <div className={classes.dateHeading}>{formatDayHeading(selectedDay)}</div>
      {eventsForDay.length === 0 && (
        <div className={classes.emptyDay}>{loading ? <PainterScheduleShim /> : 'No jobs scheduled'}</div>
      )}
      {eventsForDay.map((event) => (
        <EventListJob key={event.id} event={event} {...props} expandedJobId={expandedJobId} />
      ))}
    </div>
  )
}
